import * as XLSX from "xlsx";
import { formatDate } from "../../../../../utils/dateUtils";
import { AccountCategoryKey } from "../../../../../utils/enums";

const accountTypeLabel = (key) => {
  if (key === AccountCategoryKey.OFFBOARDED_USER) return "Offboarded User";
  if (key === AccountCategoryKey.NON_PERSON) return "Non Person / Not in Scope";
  return "-";
};

const buildRole = (staff) =>
  staff?.role === "-" ? "Not Assigned" : staff?.role || "-";


export const exportStaffToExcel = (staffData, options = {}) => {
  const inScope = options.inScope !== false;
  try {
    const exportData = [];

    if (inScope) {
      exportData.push([
        "Name",
        "Email",
        "Role",
        "Policies Accepted",
        "Background Check Done",
        "Performance Review Done",
        "Security Training Done",
        "Job Evaluation Done",
      ]);

      staffData.forEach((staff) => {
        exportData.push([
          staff?.name || "-",
          staff?.email || "-",
          buildRole(staff),
          staff?.policiesAccepted
            ? `${staff.policiesAccepted.passing}/${
                staff.policiesAccepted.total
              } ${
                staff.policiesAccepted.allAccepted
                  ? "(All Accepted)"
                  : "(Incomplete)"
              }`
            : "-",
          staff?.backgroundCheck?.status || "-",
          staff?.performanceReview?.status || "-",
          staff?.securityTraining?.status || "-",
          staff?.jobEvaluation?.status || "-",
        ]);
      });
    } else {
      exportData.push([
        "Name",
        "Email",
        "Role",
        "Account Type",
        "Reason for Inactivity",
        "Termination Date",
      ]);

      staffData.forEach((staff) => {
        exportData.push([
          staff?.name || "-",
          staff?.email || "-",
          buildRole(staff),
          accountTypeLabel(staff?.accountCategoryKey),
          staff?.scopeReason || "-",
          staff?.terminationDate ? formatDate(staff.terminationDate) : "-",
        ]);
      });
    }

    const ws = XLSX.utils.aoa_to_sheet(exportData);

    ws["!cols"] = inScope
      ? [
          { wch: 25 }, // Name
          { wch: 30 }, // Email
          { wch: 20 }, // Role
          { wch: 20 }, // Policies Accepted
          { wch: 18 }, // Background Check
          { wch: 20 }, // Performance Review
          { wch: 18 }, // Security Training
          { wch: 18 }, // Job Evaluation
        ]
      : [
          { wch: 25 }, // Name
          { wch: 30 }, // Email
          { wch: 20 }, // Role
          { wch: 24 }, // Account Type
          { wch: 28 }, // Reason for Inactivity
          { wch: 18 }, // Termination Date
        ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Staff Members");

    const timestamp = new Date().toISOString().split("T")[0];
    const filename = `Staff_Members_${timestamp}.xlsx`;

    XLSX.writeFile(wb, filename);

    return { success: true };
  } catch (error) {
    console.error("Export failed:", error);
    return { success: false, error };
  }
};
